import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store";

export default function localUpdate( newValue: Partial<ILandingStore>, descr: string="", isForce: boolean = false ) {
    console.log( newValue )
    useLandingStore.getState().updateLanding( newValue )
}